import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template"]

  add() {
    this.listTarget.append(this.templateTarget.content.cloneNode(true))
    this.listTarget.lastElementChild?.querySelector("input")?.focus()
  }

  remove(event) {
    event.target.closest("[data-key-value-row]")?.remove()
  }
}
